import { Prospector } from '@clearkit/icons';
import classNames from 'classnames';
import { CKButton } from 'clearkit';

import { trackEvent } from '~/lib/tracking';

const BulkSelectedCompaniesActions = ({
  // crmData,
  // crmConnected,
  selected,
  isSample,
  handleClear,
  type,
}: {
  // crmData?: NewVisitorReportCrmData;
  // crmConnected: boolean;
  selected: string[];
  isSample: boolean;
  handleClear: () => void;
  type: 'visitors' | 'target_markets';
}) => {
  // For upcoming add to CRM feature:
  // const selectedForCrm = selected.filter(
  //   ({ company_domain }) =>
  //     !crmData?.[company_domain]?.inHubSpot &&
  //     !crmData?.[company_domain]?.inSalesforce,
  // );

  return (
    <div
      className={classNames(
        'fixed transition-all duration-300 left-0 right-0 w-full z-[100] max-w-xs mx-auto',
        {
          'bottom-4': selected.length > 0,
          'bottom-[-100px]': selected.length === 0,
        },
      )}
    >
      <div className="flex flex-row items-center justify-center w-full p-4 ck-box gap-3">
        <CKButton
          onClick={handleClear}
          size="small"
          variant="simple"
          variantColor="red"
        >
          Clear
        </CKButton>

        {/* For upcoming add to CRM feature: */}
        {/* <CKButton
          isDisabled={selectedForCrm.length === 0}
          leftIcon={<Add />}
          onClick={() => {
            if (crmConnected) {
              alert('TBD!');
            } else {
              history.push('/settings/configuration');
            }
          }}
          size="small"
          variant="simple"
          variantColor="blue"
        >
          Add {selectedForCrm.length} to CRM
        </CKButton> */}

        <a
          className="ck-button ck-button--bold ck-button--blue ck-button--small"
          href={
            isSample
              ? ''
              : `/prospector?new=true&source=${type}&domain=${selected.join(
                  ',',
                )}`
          }
          onClick={() => {
            if (isSample) {
              window.alert(
                'This is a sample so you cannot prospect these companies, but if it was a real setup, this would search for contacts at all of the selected companies.',
              );

              return;
            }

            trackEvent(
              type === 'target_markets'
                ? 'target_markets_prospector_opened'
                : 'visitor_report_prospector_opened',
              {
                domains: selected,
                type: 'bulk',
              },
            );
          }}
          target={isSample ? undefined : '_blank'}
        >
          <Prospector className="mr-1" />
          <span>Prospect {selected.length} companies</span>
        </a>
      </div>
    </div>
  );
};

export default BulkSelectedCompaniesActions;
